import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ConfirmationService} from 'primeng/api';
import {ActivatedRoute} from '@angular/router';
import {ObjectBaseComponent} from '../../../../../core/shared/object/mvs-object-base/object-base.component';
import {MvsCoreService} from '../../../../../core/shared/service/mvs-core.service';
import {MvsMessageService} from '../../../../../core/shared/service/message/mvs-message.service';
import {ObserverService} from '../../../../../core/shared/object/service/observer.service';
import {UfFormRuntimeService} from '../../../service/domain/uf-form-runtime/uf-form-runtime.service';

@Component({
    selector: 'uf-form-object-component',
    templateUrl: 'uf-form-object.component.html',
    styleUrls: ['uf-form-object.component.scss'],
    standalone: false
})
export class UfFormObjectComponent extends ObjectBaseComponent implements OnInit, OnChanges, OnDestroy {

    formId: number;

    constructor(
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected confirmationService: ConfirmationService,
        protected override observerService: ObserverService,
        private route: ActivatedRoute,
        private formRuntimeService: UfFormRuntimeService
    ) {
        super(coreService, messageService, confirmationService, observerService);
    }

    ngOnInit() {
        super.ngOnInit();
    }

    onObjectChanged() {
        this.formId = this.objectIdentifier.objectId;
    }

    handleSave(fieldValues: { [key: string]: any }): void {
        this.formRuntimeService.saveForm(this.formId, {fieldValues}).subscribe({
            next: () => {
                this.messageService.showSuccessMessage('Formular', 'Formular wurde erfolgreich gespeichert.');
            },
            error: () => {
                this.messageService.showErrorMessage('Formular', 'Fehler beim Speichern des Formulars.');
            }
        });
    }

    handleCancel(): void {
        this.messageService.showInfoMessage('Formular', 'Bearbeitung abgebrochen.');
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
